import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { BrandThemesEnum, ThemesEnum } from '../../../_enums/themes.enum';
import { IconSizeEnum } from '../../../_enums/icon.enum';
import { ILink } from '../../../_interfaces/link.interface';
import { LinkService } from '../../../_services/link.service';
import { LinkUtils } from '../../../utils/link.utils';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdButtonComponent } from '../../buttons/button/button.component';
import { SdButtonIconComponent } from '../../buttons/button-icon/button-icon.component';

@Component({
  selector: 'sd-link',
  templateUrl: './link.component.html',
  standalone: true,
  imports: [
    RouterLinkActive,
    NgTemplateOutlet,
    RouterLink,
    SdButtonComponent,
    SdButtonIconComponent
  ]
})
export class SdLinkComponent implements OnChanges {
  constructor(
    private linkService: LinkService,
    private router: Router,
  ) {}

  isHttpUrlLink = LinkUtils.isHttpUrlLink;
  queryParams = {};
  fragment: string | null;
  splitedUrl = '';
  isScriptLink = false;
  tag = 'SCRIPT';

  @Input()
  brand: BrandsEnum;

  @Input()
  indexFollow = true;

  @Input()
  link: ILink;

  @Input()
  customClass: string;

  @Input()
  activeClass: string;

  @Input()
  isDisabled: boolean;

  @Input()
  isButton: boolean;

  @Input()
  isSecondary: boolean;

  @Input()
  isSmall: boolean;

  @Input()
  icon: string;

  @Input()
  size: IconSizeEnum;

  @Input()
  buttonIconTitle: string;

  @Input()
  titleHidden: boolean;

  @Input()
  isIcon: boolean;

  @Input()
  iconPos: PositionEnum.left | PositionEnum.right = PositionEnum.left;

  @Input()
  theme: ThemesEnum | BrandThemesEnum.brand;

  @Input()
  ariaLabel: string;

  @Input()
  tabIndex: string;

  @Input()
  role: string;

  @Input()
  rel: string;

  @Output()
  clicked = new EventEmitter<string>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.theme ? 'is-theme-' + this.theme : '']
      .filter(Boolean)
      .join(' ');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.link && !this.isHttpUrlLink(this.link?.url)) {
      this.getQueryParams();
    }
    if (changes?.link && this.link?.url?.includes(this.tag)) {
      this.isScriptLink = true;
    }
  }

  containsNewBrand(url?: string): boolean {
    if (!url) return false;

    const activeUrl = url.toLowerCase();
    const currentHref = window.location.href.toLowerCase();
    const brandValues = Object.values(BrandsEnum)
      .filter(Boolean)
      .map((b) => b.toLowerCase());

    return brandValues.some(
      (brand) => activeUrl.includes(brand) && !currentHref.includes(brand)
    );
  }

  onClick(event?: Event) {
    const linkUrl = this.link?.url;

    this.clicked.emit(linkUrl);
    this.linkService.sendClickLinkEvent(this.link);

    if (this.containsNewBrand(linkUrl)) {
      window.location.href = linkUrl;
      return;
    }

    if (linkUrl?.includes('<<chat>>')) {
      event?.preventDefault();
      return;
    }

    if (linkUrl) {
      if (this.isHttpUrlLink(linkUrl)) {
        window.location.href = linkUrl;
      } else {
        this.router.navigateByUrl(linkUrl);
      }
    }
  }

  getQueryParams() {
    const url = this.link?.url;
    this.queryParams = {};
    if (url) {
      this.splitedUrl = url?.split('?')[0];

      const parsedUrl = this.router.parseUrl(url);
      this.queryParams = parsedUrl?.queryParams;

      if (parsedUrl?.fragment) {
        this.fragment = parsedUrl?.fragment;
        this.splitedUrl = this.splitedUrl.split('#')[0];
      }
    }
  }

  clickScriptLink(event, str: string) {
    event.preventDefault();
    const scriptStr = str
      .split('[' + this.tag + ']', 2)[1]
      ?.split('[/' + this.tag + ']')[0]
      .replaceAll(';', '');
    Function(`"use strict"; return ${scriptStr}`)();
  }
}
